<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'CRM.ASSOCIATION_PANEL.REPORTS.TITLE' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>

  @if (reportCardsReady$ | async) {
    @if (snapshot$ | async; as snapshot) {
      @if ((snapshotLoading$ | async) === false) {
        <mat-card class="association-card-contents-with-actions" appearance="outlined">
          <mat-card-title class="content-beside-actions">
            <a (click)="navToViewSnapshot()">{{ snapshotName$ | async }}</a>
            <mat-card-subtitle>
              {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.CREATED' | translate }}:
              {{ snapshot.created | date: 'mediumDate' }}
              <div class="status-badge">
                @if (snapshot.expired < this.now) {
                  <glxy-badge [color]="'grey'">
                    {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.STATUS.EXPIRED' | translate }}
                  </glxy-badge>
                } @else {
                  <glxy-badge [color]="'green'">
                    {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.STATUS.ACTIVE' | translate }}
                  </glxy-badge>
                }
              </div>
            </mat-card-subtitle>
          </mat-card-title>
          <button mat-icon-button color="primary" [matMenuTriggerFor]="actions">
            <mat-icon class="gray-icon">more_vert</mat-icon>
          </button>
          <mat-menu #actions>
            <button mat-menu-item (click)="navToViewSnapshot()">
              {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.ACTIONS.VIEW' | translate }}
            </button>
            <button mat-menu-item (click)="navToEditSnapshot()">
              {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.ACTIONS.EDIT' | translate }}
            </button>
            @if (snapshot.expired < this.now) {
              <button mat-menu-item (click)="refreshSnapshot()">
                {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.ACTIONS.REFRESH' | translate }}
              </button>
            }
          </mat-menu>
        </mat-card>
      } @else {
        <glxy-loading-spinner id="spinner-container" [fullWidth]="true" [fullHeight]="true"></glxy-loading-spinner>
      }
    } @else {
      @if (creatingSnapshot$ | async) {
        <button mat-stroked-button color="primary" class="card-button" disabled>
          <glxy-loading-spinner size="small"></glxy-loading-spinner>
        </button>
      } @else {
        @if (snapshotName$ | async; as snapshotName) {
          <button mat-stroked-button color="primary" class="card-button" (click)="createSnapshot()">
            <mat-icon>note_add</mat-icon>
            <div>
              {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.ACTIONS.CREATE' | translate: { snapshotName } }}
            </div>
          </button>
        }
      }
    }
  } @else {
    <glxy-loading-spinner id="spinner-container" [fullWidth]="true" [fullHeight]="true"></glxy-loading-spinner>
  }
</mat-expansion-panel>
